// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2c7cr","header":"PatientQuestionnaire_header__3HRxN","info":"PatientQuestionnaire_info__2Gk1l"};